<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-import"
      scrollable
      centered
      button-size="sm"
      size="lg"
      @hidden="onReset"
    >
      <template #modal-title>
        <i class="fas fa-columns"></i> CRM - Importação
      </template>
      <div class="row">
        <div class="col-md-12">
          <label for="txtGroup"> Quadro:</label>
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-columns"></i
            ></span>
            <b-form-input
              type="text"
              v-model="boardName"
              readonly
            />
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <label for="txtGroup"
            ><small
              class="text-danger"
              v-if="form.boardColumnId.required"
              >*</small
            >
            Coluna:</label
          >
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-square"></i></span>
            <b-form-select
              v-model="form.boardColumnId.value"
              :options="form.boardColumnId.options"
            >
              <template slot="first">
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 mt-2">
          <label for="txtGroup"
            ><small
              class="text-danger"
              v-if="form.origemLeadId.required"
              >*</small
            >
            Origem:</label
          >
          <div class="input-group">
            <span class="input-group-addon"
              ><i class="fas fa-bullhorn"></i
            ></span>
            <b-form-select
              v-model="form.origemLeadId.value"
              :options="form.origemLeadId.options"
            >
              <template slot="first">
                <option :value="null">
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-12 mt-2 pt-3">
          <div class="form-group">
            <div class="input-group">
              <b-form-checkbox
                id="vincularGerenteCard"
                name="vincularGerenteCard"
                v-model="form.vincularGerenteAoCard.value"
              >
                Vincular Gerente ao Card?
              </b-form-checkbox>
              <b-form-checkbox
                id="vincularGerenteRelacionamento"
                name="vincularGerenteRelacionamento"
                v-model="form.vincularGerenteRelacionamento.value"
              >
                Vincular Gerente de Relacionamento?
              </b-form-checkbox>
              <b-form-checkbox
                id="atualizarClusterizacao"
                name="atualizarClusterizacao"
                v-model="form.atualizarClusterizacao.value"
              >
                Atualizar Clusterização?
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-2">
          <div class="form-group">
            <label for="txtDescription"> Importar Arquivo:</label>
            <div
              draggable="true"
              @drop.prevent="onDrop"
              @dragover.prevent
              class="block-upload"
              @click="addFile()"
            >
              <div
                v-if="file === null"
                class="text-center pt-5 pb-5"
              >
                Clique ou arraste e solte os arquivos aqui
              </div>
              <div
                v-else
                class="text-center pt-5 pb-5"
              >
                {{ file.name }}
              </div>
            </div>
            <div style="display: none">
              <input
                type="file"
                ref="planilha"
                @change="handleFileUpload()"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/excel"
              />
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-4">
          <div class="form-group">
            <label for="txtDescription"> Modelo do Arquivo:</label>
            <div>
              <li>
                <a
                  href="https://static.nexum.com.br/template/planilhas/v2/GerarCards.xlsx"
                  target="_blank"
                  ><i class="fas fa-file-excel text-third"></i
                  ><small class="pl-1"
                    >Clique aqui para baixar o modelo do arquivo de
                    importação.</small
                  ></a
                >
              </li>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            @click="onClickImport"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Salvar'"
          >
            <i class="fas fa-check-circle"></i
            ><span class="d-md-down-none"> Importar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'

import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import _ from 'lodash'
import * as XLSX from 'xlsx'

let form = {
  boardColumnId: {
    value: null,
    defaultValue: null,
    options: [],
    required: true,
    state: null
  },
  origemLeadId: {
    value: null,
    defaultValue: null,
    options: [],
    required: true,
    state: null
  },
  vincularGerenteAoCard: {
    value: false,
    defaultValue: false,
    state: null
  },
  vincularGerenteRelacionamento: {
    value: false,
    defaultValue: false,
    state: null
  },
  atualizarClusterizacao: {
    value: false,
    defaultValue: false,
    state: null
  }
}

let data = {
  boardColumnId: null,
  origemLeadId: null,
  vincularGerenteAoCard: null,
  vincularGerenteRelacionamento: null,
  atualizarClusterizacao: null,
  cardImportableDTOList: []
}

export default {
  name: 'CRMImport',
  mixins: [ActionsForm],
  data () {
    return {
      data: _.cloneDeep(data),
      form: _.cloneDeep(form),
      board: null,
      file: null,
      cards: [],
      verifiedCards: []
    }
  },
  computed: {
    importFile () {
      var result = []
      if (this.files && this.files.length > 0) {
        result = this.files
      }
      return result
    },
    boardName () {
      if (this.board && this.board.nome) {
        return this.board.nome
      }

      return ''
    }
  },
  watch: {
    file (value) {
      if (value !== null) {
        this.onReadFile()
      }
    }
  },
  methods: {
    showModal (board) {
      this.board = board

      this.onGetAllOrigin()
      this.onGetAllBoardColumns()

      this.$refs['modal-import'].show()
    },
    hideModal () {
      this.$refs['modal-import'].hide()
    },
    onReset () {
      this.data = _.cloneDeep(data)
      this.form = _.cloneDeep(form)
      this.board = null
      this.file = null
      this.cards = []
    },
    onLoad () {},
    onGetAllOrigin () {
      loading.push()
      OriginRepository.GetAllActive()
        .then((response) => {
          this.form.origemLeadId.options = this.onResultDropdown(
            response,
            null,
            (f) => f.nome
          )
        })
        .catch(this.onException)
    },
    onGetAllBoardColumns () {
      loading.push()
      BoardRepositoryV2.Column_GetAllActive(this.board.id)
        .then((response) => {
          this.form.boardColumnId.options = this.onResultDropdown(
            response,
            null,
            (f) => f.nome
          )
        })
        .catch(this.onException)
    },
    addFile () {
      this.$refs.planilha.click()
    },
    handleFileUpload () {
      var file = this.$refs.planilha.files[0]
      this.file = file
    },
    onDragOver (event) {
      event.preventDefault()
      event.dataTransfer.dropEffect = 'move'
    },
    onDrop (event) {
      var file = event.dataTransfer.files[0]
      this.file = file
    },
    onReadFile () {
      const reader = new FileReader()
      let excelData = []

      reader.onload = () => {
        loading.push()
        const fileData = reader.result
        const wb = XLSX.read(fileData, { type: 'binary' })

        wb.SheetNames.forEach((sheetName) => {
          excelData.push(...XLSX.utils.sheet_to_json(wb.Sheets[sheetName]))
        })

        this.parseToCard(excelData)
        loading.pop()
      }

      reader.readAsBinaryString(this.file)
    },
    parseToCard (data) {
      let cards = []
      if (data && data.length > 0) {
        cards = data.map((card) => ({
          numId: card.NUMID,
          nomeCliente: card.NOME_CLIENTE,
          clusterizacao: card.CLUSTERIZACAO,
          gerenteResponsavel: card.GERENTE_RESPONSAVEL,
          pa: card.PA,
          renda: card.RENDA,
          tipoPessoa: card.TIPO_PESSOA,
          titularidade: card.TITULARIDADE,
          cpfCnpj: card.CPF_CNPJ,
          telefoneCelular: card.TELEFONE_CELULAR,
          email: card.EMAIL
        }))
      }
      this.cards = cards
    },
    async onClickImport () {
      loading.push()
      await this.onImport()
    },
    onImport () {
      if (Tools.ValidateForms(this.form, this.data, this, toast)) {
        if (this.data) {
          // eslint-disable-next-line
          this.data.cardImportableDTOList = this.cards

          CardRepository.Import(this.data)
            .then((response) => {
              if (response.status === 200) {
                this.hideModal()
                loading.pop()
                toast.success(this.$lang.Common.Alerts.Success)
              }
            })
            .catch(this.onException)
        } else {
          loading.pop()
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    }
  }
}
</script>

<style scoped>
.block-upload {
  border: dashed 1px #ccc;
  border-radius: 5px;
  background-color: #f8f9fa;
  cursor: pointer;
}

.block-upload:hover {
  font-weight: bold;
  /*
  -webkit-transform: scale(1.2);
  -ms-transform: scale(1.2);
  transform: scale(1.2);
  transition: 1s ease;
  */
}

li {
  list-style-type: none;
}

li div {
  cursor: pointer;
  width: auto;
  display: initial;
}

.excel-color {
  color: #019727;
  padding-top: 10px;
}

.upload {
  height: 300%;
  width: 100%;
  opacity: 0.9;
  text-align: center;
  background: #efefef;
  display: block;
  position: absolute;
  z-index: 9;
  overflow: hidden;
  top: 0;
  left: 0;
}

.uploadText h2 {
  width: 100%;
  text-align: center;
  margin-top: 20%;
  display: block;
  position: absolute;
  z-index: 99999;
  top: 0;
  left: 0;
}

.uploadText h2 i {
  color: #04a791;
}

.upload-loading {
  display: block;
  position: absolute;
  z-index: 99999;
  top: 45%;
  left: 45%;
}

.upload-loading-img {
  margin: auto;
  display: block;
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/modal/crmimportmodal.vue